module.exports = __webpack_public_path__ + "5e8ffcd28ac94c6f73990bbf690bec48.svg";